import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Linkedin = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="linkedin" clipPath="url(#clip0_3001_4875)">
        <path
          id="Vector (Stroke)"
          d="M2.74609 1.50012C2.41457 1.50012 2.09663 1.63182 1.86221 1.86624C1.62779 2.10066 1.49609 2.4186 1.49609 2.75012V13.2501C1.49609 13.5816 1.62779 13.8996 1.86221 14.134C2.09663 14.3684 2.41457 14.5001 2.74609 14.5001H13.2461C13.5776 14.5001 13.8956 14.3684 14.13 14.134C14.3644 13.8996 14.4961 13.5816 14.4961 13.2501V2.75012C14.4961 2.4186 14.3644 2.10066 14.13 1.86624C13.8956 1.63182 13.5776 1.50012 13.2461 1.50012H2.74609ZM1.1551 1.15913C1.57706 0.737175 2.14936 0.500122 2.74609 0.500122H13.2461C13.8428 0.500122 14.4151 0.737175 14.8371 1.15913C15.259 1.58109 15.4961 2.15338 15.4961 2.75012V13.2501C15.4961 13.8469 15.259 14.4192 14.8371 14.8411C14.4151 15.2631 13.8428 15.5001 13.2461 15.5001H2.74609C2.14936 15.5001 1.57706 15.2631 1.1551 14.8411C0.733147 14.4192 0.496094 13.8469 0.496094 13.2501V2.75012C0.496094 2.15339 0.733147 1.58109 1.1551 1.15913ZM4.49609 4.00012C4.77224 4.00012 4.99609 4.22398 4.99609 4.50012V4.50887C4.99609 4.78501 4.77224 5.00887 4.49609 5.00887C4.21995 5.00887 3.99609 4.78501 3.99609 4.50887V4.50012C3.99609 4.22398 4.21995 4.00012 4.49609 4.00012ZM4.49609 6.62512C4.77224 6.62512 4.99609 6.84898 4.99609 7.12512V11.5001C4.99609 11.7763 4.77224 12.0001 4.49609 12.0001C4.21995 12.0001 3.99609 11.7763 3.99609 11.5001V7.12512C3.99609 6.84898 4.21995 6.62512 4.49609 6.62512ZM8.48343 7.01281C8.43246 6.79075 8.23362 6.62512 7.99609 6.62512C7.71995 6.62512 7.49609 6.84898 7.49609 7.12512V11.5001C7.49609 11.7763 7.71995 12.0001 7.99609 12.0001C8.27224 12.0001 8.49609 11.7763 8.49609 11.5001V8.87512C8.49609 8.5436 8.62779 8.22566 8.86221 7.99124C9.09663 7.75682 9.41457 7.62512 9.74609 7.62512C10.0776 7.62512 10.3956 7.75682 10.63 7.99124C10.8644 8.22566 10.9961 8.5436 10.9961 8.87512V11.5001C10.9961 11.7763 11.22 12.0001 11.4961 12.0001C11.7722 12.0001 11.9961 11.7763 11.9961 11.5001V8.87512C11.9961 8.27838 11.759 7.70609 11.3371 7.28413C10.9151 6.86218 10.3428 6.62512 9.74609 6.62512C9.29269 6.62512 8.85339 6.76198 8.48343 7.01281Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_3001_4875">
          <rect width="16" height="16" />
        </clipPath>
      </defs>
    </svg>
  );
};

Linkedin.displayName = 'Linkedin';
